export default __webpack_public_path__ + "static/media/time-until-mint.aba77ac1.png";